"use strict";
/*
 * Created on 27.12.2018
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DataObjectConverter_1 = require("../../core/conversions/DataObjectConverter");
/**
 * @author MSu
 */


var SessionInfoConverter =
/*#__PURE__*/
function (_DataObjectConverter_) {
  _inherits(SessionInfoConverter, _DataObjectConverter_);

  function SessionInfoConverter() {
    _classCallCheck(this, SessionInfoConverter);

    return _possibleConstructorReturn(this, _getPrototypeOf(SessionInfoConverter).apply(this, arguments));
  }

  return SessionInfoConverter;
}(DataObjectConverter_1.DataObjectConverter);

exports.SessionInfoConverter = SessionInfoConverter;